import React, { FunctionComponent } from "react";

import { bemClassNames, transformKeysToParamCase } from "@multiweb/reactUtils";

const classNames = bemClassNames("spinner-component");
const spinnerLeft = classNames("left");
const spinnerRight = classNames("right");
const spinnerBorderRight = classNames("border-right");
const spinnerBorderLeft = classNames("border-left");

export enum SpinnerSize {
    small = "small",
    fullscreen = "fullscreen",
    toolbar = "toolbar",
}

export enum SpinnerTheme {
    gray = "gray",
    light = "light",
    colored = "colored",
}

export type SpinnerComponentProps = {
    theme?: SpinnerTheme;
    size?: SpinnerSize;
};

export const SpinnerComponent: FunctionComponent<SpinnerComponentProps> = ({ theme, size }) => (
    <div className={classNames(transformKeysToParamCase({
        theme,
        size,
    }))}>
        <div className={spinnerRight}>
            <div className={spinnerBorderRight}></div>
        </div>
        <div className={spinnerLeft}>
            <div className={spinnerBorderLeft}></div>
        </div>
    </div>
);
